module.exports = "/static/assets/d7eb1e753d603d291d24509c5389d92b.jpg";